/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllCloudBackupPlans = (state) => values(get(state, ['cloudBackupPlans', 'items']));

export const requestingCloudBackupPlans = (state) => get(state, ['cloudBackupPlans', 'requesting']);

export const errorRequestingCloudBackupPlans = (state) => get(state, ['cloudBackupPlans', 'error']);